module.exports = __webpack_public_path__ + "static/media/checkbox-arrow.91b41c52.svg";